const BASE_URL = 'https://beta.sdbooks.com';
const FAST_API_URL = 'https://apitest.theralink.ai';

export const environment = {
  production: false,
  authServiceBasePath: `${BASE_URL}/authentication-service/api/v1/`,
  planningServieBasePath: `${BASE_URL}/planning-service/api/v1/`,
  planningServieBasePathV2: `${BASE_URL}/planning-service/api/v2/`,
  adminServiceBasePath: `${BASE_URL}/admin-service/api/v1/`,
  adminServiceBasePathV2: `${BASE_URL}/admin-service/api/v2/`,
  basePath: `${BASE_URL}/api/v1/`,
  basePathV2: `${BASE_URL}/api/v2/`,
  fastApiUrl: FAST_API_URL,
  // Chat is path-routed on the same host: /api/chat → chat microservice
  chatApiUrl: FAST_API_URL,
  schedulerLicenseKey: '0481234875-fcs-1782827413',
  captcha: '6LeI3uAUAAAAAKV1GD_hbtJ4q9o-Da_I622N2_Ct',
};
